import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import Loader from '@bharatpe/bharat-ui/web/Loader';
import { showPostPeUI, showTwelvePcUI, showZillionUi } from 'utils/Utils';

import store from 'store';
import LoaderNew from 'components/atoms/Loader';
import Home from 'containers/Home';
import JuspayMicroWebView from 'containers/JuspayMicroWebView';
import JuspayLandingPage from 'containers/JuspayLandingPage';
import JuspayBharatpeLandingPage from 'containers/JuspayBharatpeLandingPage';
import JuspayWebIntermediaryPage from 'containers/JuspayWebIntermediaryPage';
import JuspayWebLandingPage from 'containers/JuspayWebLandingPage';
import BharatPeXLandingPage from 'containers/BharatPeXLandingPage';
import UPIActivationStatus from 'containers/UPIContainer/Registration/UPIActivationStatus';
import SimBinding from 'containers/UPIContainer/SimBinding';
import BankSelection from 'containers/UPIContainer/BankSelection';
import UpiSucessfull from 'containers/UPIContainer/UpiSuccefullyCreated';
import AutoPayLanding from 'containers/UPIContainer/AutoPayLanding';
import AutoPay from 'containers/UPIContainer/AutoPay';
import ProfileDetails from 'containers/Account/ProfileDetails';
import TransactionList from 'containers/Account/TransactionList';
import ManageAutoPayList from 'containers/Account/ManageAutoPayList';
import AutopayDetails from 'containers/Account/AutopayDetails';
import AutoPayPaymentStatus from 'containers/UPIContainer/AutoPayPaymentStatus';
import UdirDetails from 'containers/UPIContainer/UDIR/UdirDetails';
import SimFailure from 'containers/UPIContainer/SimBinding/SimFailure';
import MandateSuccessfull from 'containers/UPIContainer/MandateSuccessful';
import SimBindingFailure from 'containers/UPIContainer/SimBinding/SimBindingFailure';
import DelinkSuccess from 'containers/Account/DelinkSuccess';
import UPISettings from 'containers/Account/UPISettings';
import ReclaimBankList from 'containers/UPIContainer/ReclaimBankList';
import BankAccountDetails from 'containers/Account/BankAccountDetails';
import BankList from 'containers/Account/BankList';
import AutopayCollectRequest from 'containers/UPIContainer/AutopayCollectRequest';
import CollectAutoPayDetails from 'containers/UPIContainer/CollectAutoPayDetails';
import ApproveToPay from 'containers/Account/ApproveToPay';
import CollectRequestStatus from 'containers/UPIContainer/CollectRequestStatus';

const isShowTwelvePcUI = showTwelvePcUI();
const isShowPostPeUI = showPostPeUI();
const isShowZillionUi = showZillionUi();

const PaymentView = React.lazy(() => import('containers/PaymentView'));
const upiPayment = React.lazy(() => import('../../src/components/atoms/UpiPayment'));
const CheckStatus = React.lazy(() => import('../containers/CheckStatus'));
const ThanksView = React.lazy(() => import('../containers/ThanksView'));

const Routes: React.FC = () => (
	<Provider store={store}>
		<Suspense
			fallback={
				isShowPostPeUI ? (
					<div>Loading</div>
				) : isShowTwelvePcUI || isShowZillionUi ? (
					<LoaderNew loading loaderType={isShowTwelvePcUI ? '12pc' : 'zillion'} />
				) : (
					<Loader loading />
				)
			}>
			<Router basename={process.env.PUBLIC_URL}>
				<Switch>
					<Route exact path="/" component={Home} />
					<Route path={`/payment`} component={PaymentView} />
					<Route path={'/upi-pay'} component={upiPayment} />
					<Route path={'/check-status'} component={CheckStatus} />
					<Route path={`/thanks`} component={ThanksView} />
					<Route path="/juspay-micro-webview" component={JuspayMicroWebView} />
					<Route path="/juspay-landing/:pageSource" component={JuspayLandingPage} />
					<Route path="/bpx-landing/:pageSource" component={BharatPeXLandingPage} />
					<Route path="/bharatpe-landing/:checkout" component={JuspayBharatpeLandingPage} />
					<Route path="/juspay-web-intermediary" component={JuspayWebIntermediaryPage} />
					<Route path="/juspay-web-landing" component={JuspayWebLandingPage} />
					<Route path="/upi/upi-activation-status" component={UPIActivationStatus} />
					<Route path="/upi/sim-binding" component={SimBinding} />
					<Route path="/upi/sim-binding-failure" component={SimBindingFailure} />
					<Route path="/upi/sim-failure" component={SimFailure} />
					<Route path="/upi/bank-selection" component={BankSelection} />
					<Route path="/upi/upi-created" component={UpiSucessfull} />
					<Route path="/upi/auto-pay-successfull" component={MandateSuccessfull} />
					<Route path="/upi/auto-pay-landing" component={AutoPayLanding} />
					<Route path="/upi/auto-pay" component={AutoPay} />
					<Route path="/upi/auto-pay-collect-request" component={AutopayCollectRequest} />
					<Route path="/upi/collect-auto-pay-details" component={CollectAutoPayDetails} />
					<Route path="/upi/collect-request-status" component={CollectRequestStatus} />
					<Route path="/account/upi-settings" component={UPISettings} />
					<Route path="/account/bank-account-details" component={BankAccountDetails} />
					<Route path="/upi/reclaim-bank-list" component={ReclaimBankList} />
					<Route path="/account/bank-list" component={BankList} />
					<Route path="/account/approve-to-pay" component={ApproveToPay} />
					<Route path="/account/profile-details" component={ProfileDetails} />
					<Route path="/account/transaction-list" component={TransactionList} />
					<Route path="/account/manage-auto-pay" component={ManageAutoPayList} />
					<Route path="/account/auto-pay-details" component={AutopayDetails} />
					<Route path="/upi/auto-pay-payment-status" component={AutoPayPaymentStatus} />
					<Route path="/upi/udir/details" component={UdirDetails} />
					<Route path="/account/delink-success" component={DelinkSuccess} />
				</Switch>
			</Router>
		</Suspense>
	</Provider>
);

export default React.memo(Routes);
